const ROOTS = {
  AUTH: '/auth',
  MAIN: '/dashboard',
}

export const paths = {
  auth: {
    login: '/',
  },

  dashboard: {
    root: ROOTS.MAIN,
  },
}
